





























import { Call } from '@/shared/call';
import { CallReason } from '@/shared/call-reason';
import { CallType } from '@/shared/call-type';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

@Component
export default class NextAvailableCallTable extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;
    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;

    @Prop({ required: true }) private call!: Call;

    private get calls(): Array<Call> {
        return this.call == null ? [] : [{ ...this.call! }];
    }

    private get callFields(): Array<{}> {
        return [
            { key: 'accountNo', label: 'Account No' },
            { key: 'client', label: 'Client Name' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'originalSource', label: 'Introducer' },
            { key: 'date', label: 'Call Due Date' },
            { key: 'time', label: 'Time' },
            { key: 'type', label: 'Call Type' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private clientName(call: Call): string {
        return `${call.firstName!.trim()} ${call.lastName!.trim()}`.trim();
    }

    private originalSourceDescription(originalSourceId: string | null): string {
        const originalSource = this.clientOriginalSourceTypes.find((type) => type.id! === originalSourceId!);
        return originalSource == null ? '' : originalSource.value;
    }

    private callTypeText(type: CallType): string {
        switch (type) {
            case CallType.Call:
                return 'Call';
            case CallType.Callback:
                return 'Callback';
            default:
                return '';
        }
    }

    private callReasonText(reason: CallReason): string {
        switch (reason) {
            case CallReason.General:
                return 'General';
            case CallReason.CancelledAppointment:
                return 'Appointment Cancelled';
            case CallReason.GeneralReview:
                return 'General Review';
            case CallReason.NoShow:
                return 'No Show';
            default:
                return '';
        }
    }
}
